export default __webpack_public_path__ + "static/media/PAFI_Calon Anggota Direksi PT PFI Tbk 2026.79ad07e5.pdf";